<template>
    <div id="login">
        <div class="lgWrapper limiter container-login100" style="background-image: url('static/bg-01.jpg');">
            <div class="wrap-login100">
                <span class="login100-form-logo p-b-34">
                    <img src="/static/logo_login.png" width="100%"/>
                </span>
                <span class="login100-form-title p-b-34 p-t-100">
                    Đăng nhập
                </span>
                <span v-if="wrong_user_pass" class="message-error text-yellow">{{error_message}}</span>
                <span v-if="null_user_pass" class="message-error text-yellow">{{null_message}}</span>
                <ul class="lgForm">
                    <li class="username">
                        <input type="text" name="username" v-model="model.email" class="form-control" required placeholder="Tên đăng nhập" />
                    </li>
                    <li class="password">
                        <input type="password" name="password" v-model="model.password" class="form-control" required placeholder="Mật khẩu" v-on:keyup.13="login()"  />
                    </li>
                    <li>
                        <button type="button" v-on:click="login()" class="btn btn-login">Đăng nhập</button>
                    </li>
                    <!-- <div class="row">
                        <div class="col-6">
                            <router-link to="/quen-mat-khau" replace class="fgLink fr">Quên mật khẩu?</router-link>
                        </div>
                        <div class="col-6">
                            <router-link to="/dang-ky" replace class="fgLink fr align-right">Đăng ký</router-link>
                        </div>
                    </div> -->
                </ul>
            </div>
        </div>
    </div>    
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        loading: false,
        model: {
            email: '',
            password: ''
        },
        snackbar: false,
        message: '',
        error_message: "Tài khoản hoặc mật khẩu không đúng.",
        null_message: "Tài khoản và mật khẩu không được để trống.",
        wrong_user_pass: false,
        null_user_pass: false,
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 400) {
                this.wrong_user_pass = true;
                this.message = 'Tài khoản hoặc mật khẩu không đúng.'
            } else if (this.token && this.token !== '') {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }
            this.loading = false;
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.wrong_user_pass = false;
            this.null_user_pass = this.model.email === '' || this.model.password === '';
            if (!this.null_user_pass) {
                this.$store.dispatch('authentication/login', this.model);
            }
        }
    }

};
</script>

<style lang="css" scoped>
#login {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-image: linear-gradient(#350b5a, #ffffff);
}
.lgWrapper {
    background-color: transparent;
}
.align-right{
  float: right;
}
.align-center {
    border: none;
    align-content: center;
}
</style>
